import React from "react";
import Carrier_list_order from "./Carrier_list_order";
import Order_data from "./Order_data";
import Shipment_data from "./Shipment_data";

const Common = () => {
  return (
    <div>
      {/* <!-- Offcanvas Order_Filter --> */}
      <div class="offcanvas offcanvas-end" id="Order_Filter">
        <div class="offcanvas-header">
          <h2 class="offcanvas-title">Order Filters</h2>
          <button
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>
        <div class="offcanvas-body">
          <div class="card mb-3">
            <div class="card-body">
              <h6>Payment Mode</h6>

              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Prepaid
                </label>
              </div>
              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  COD (Cash On Delivery)
                </label>
              </div>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-body">
              <h6>Warehouse Pickup Locations</h6>

              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Navi Mumbai
                </label>
              </div>
              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Karol Bagh Delhi
                </label>
              </div>
            </div>
          </div>
          <div class="d-grid">
            <a href="" class="btn btn-primary btn-block">
              Apply Filter
            </a>
          </div>
        </div>
      </div>

      {/* <!-- Offcanvas NDR_Filter --> */}
      <div class="offcanvas offcanvas-end" id="NDR_Filter">
        <div class="offcanvas-header">
          <h2 class="offcanvas-title">NDR Filters</h2>
          <button
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>
        <div class="offcanvas-body">
          <div class="card mb-3">
            <div class="card-body">
              <h6>Pending Since</h6>

              <div>
                <div class="form-check mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox1"
                    value="option1"
                  />
                  <label class="form-check-label" for="inlineCheckbox1">
                    Today
                  </label>
                </div>
                <div class="form-check mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox1"
                    value="option1"
                  />
                  <label class="form-check-label" for="inlineCheckbox1">
                    Yesterday
                  </label>
                </div>
                <div class="form-check mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox1"
                    value="option1"
                  />
                  <label class="form-check-label" for="inlineCheckbox1">
                    2 Days ago
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-body">
              <h6>Payment Mode</h6>

              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Prepaid
                </label>
              </div>
              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  COD (Cash On Delivery)
                </label>
              </div>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-body">
              <h6>Attempts</h6>

              <select class="form-select">
                <option>All</option>
                <option>Attempt 1</option>
                <option>Attempt 2</option>
                <option>Attempt 3</option>
                <option>Attempt 4</option>
                <option>Attempt 5</option>
              </select>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-body">
              <h6>Channel</h6>

              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  The biz store - Shopify
                </label>
              </div>
              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Nameland India - Woocomerce
                </label>
              </div>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-body">
              <h6>Couriers</h6>
              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Amazon 500gm
                </label>
              </div>
              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Amazon 1KG
                </label>
              </div>
              <a
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#more_carriers"
              >
                View more
              </a>

              <div id="more_carriers" class="collapse">
                <div class="form-check form-switch  mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckChecked"
                    checked
                  />
                  <label class="form-check-label" for="flexSwitchCheckChecked">
                    Amazon 500gm
                  </label>
                </div>
                <div class="form-check form-switch  mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckChecked"
                    checked
                  />
                  <label class="form-check-label" for="flexSwitchCheckChecked">
                    Amazon 1KG
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="d-grid">
            <a href="" class="btn btn-primary btn-block">
              Apply Filter
            </a>
          </div>
        </div>
      </div>

      {/* <!-- Offcanvas Shipment_Filter --> */}
      <div class="offcanvas offcanvas-end" id="Shipment_Filter">
        <div class="offcanvas-header">
          <h2 class="offcanvas-title">Shipment Filters</h2>
          <button
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>
        <div class="offcanvas-body">
          <div class="card mb-3">
            <div class="card-body">
              <h6>Shipment Status</h6>

              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Delivered
                </label>
              </div>
              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  In Transit
                </label>
              </div>
              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  RTO
                </label>
              </div>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-body">
              <h6>Payment Mode</h6>

              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Prepaid
                </label>
              </div>
              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  COD (Cash On Delivery)
                </label>
              </div>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-body">
              <h6>Warehouse Pickup Locations</h6>

              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Navi Mumbai
                </label>
              </div>
              <div class="form-check form-switch  mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  Karol Bagh Delhi
                </label>
              </div>
            </div>
          </div>
          <div class="d-grid">
            <a href="" class="btn btn-primary btn-block">
              Apply Filter
            </a>
          </div>
        </div>
      </div>

      {/* <!-- Order Data View --> */}
      <section class="order_data">
        <div class="offcanvas offcanvas-end " id="Order_data">
          <div class="offcanvas-header shadow-sm">
            <h4 class="offcanvas-title">Orders #298239842348</h4>
            <div class="dropdown text-end">
              <button
                type="button"
                class="btn btn-outline-primary btn-block dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Actions
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#">
                    {" "}
                    Edit Order
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    {" "}
                    Clone Order
                  </a>
                </li>
                <li>
                  <a class="dropdown-item text-danger" href="#">
                    {" "}
                    Cancel Order
                  </a>
                </li>
              </ul>
            </div>
            <button
              type="button"
              class="btn-close text-reset"
              data-bs-dismiss="offcanvas"
            ></button>
          </div>
          <div class="offcanvas-body">
            <Order_data />
          </div>
        </div>
      </section>

      {/* <!-- Order Data View --> */}
      <section class="order_data">
        <div class="offcanvas offcanvas-end " id="Shipment_data">
          <div class="offcanvas-header shadow-sm">
            <h4 class="offcanvas-title">Shipment #298239842348</h4>
            <div class="shipm_tablew">
              <span class="status pickedup">
                {" "}
                <i class="fa fa-check" aria-hidden="true"></i> Pickedup
              </span>
            </div>
            <div class="dropdown text-end">
              <button
                type="button"
                class="btn btn-outline-primary btn-block dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Actions
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#">
                    {" "}
                    Edit Order
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    {" "}
                    Clone Order
                  </a>
                </li>
                <li>
                  <a class="dropdown-item text-danger" href="#">
                    {" "}
                    Cancel Order
                  </a>
                </li>
              </ul>
            </div>
            <button
              type="button"
              class="btn-close text-reset"
              data-bs-dismiss="offcanvas"
            ></button>
          </div>
          <div class="offcanvas-body">
            <Shipment_data />
          </div>
        </div>
      </section>

      {/* <!-- Carrier show list Offcanvas --> */}
      <section class="order_data">
        <div class="offcanvas offcanvas-end" id="Carrier_lists">
          <div class="offcanvas-header">
            <h4 class="offcanvas-title">Select Courier Partner</h4>
            <button
              type="button"
              class="btn-close text-reset"
              data-bs-dismiss="offcanvas"
            ></button>
          </div>
          <div class="offcanvas-body">
            <Carrier_list_order />
          </div>
        </div>
      </section>

      {/* <!-- Add/Edit Warehouse Modal --> */}
      <div class="modal" id="Warehouse_up">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Warehouse</h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-md-6 mb-3">
                  <label for="email" class="form-label">
                    Full Name:
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="text"
                    placeholder="Enter Your full name"
                  />
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <label for="email" class="form-label">
                    Warehouse Name:
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="text"
                    placeholder="Enter Your Warehouse Name"
                  />
                </div>
                <div class="col-12 col-md-3">
                  <label for="email" class="form-label">
                    Select Country:
                  </label>
                  <select class="form-select form-select-sm">
                    <option>Select Country</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                </div>
                <div class="col-12 col-md-3">
                  <label for="email" class="form-label">
                    Select State:
                  </label>
                  <select class="form-select form-select-sm">
                    <option>Select State</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                </div>
                <div class="col-12 col-md-3">
                  <label for="email" class="form-label">
                    Select City:
                  </label>
                  <select class="form-select form-select-sm">
                    <option>Select City</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                </div>
                <div class="col-12 col-md-3">
                  <label for="email" class="form-label">
                    Select Pincode:
                  </label>
                  <select class="form-select form-select-sm">
                    <option>Select Pincode</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                </div>
                <div class="col-12 col-md-12 mb-3 mt-3">
                  <label for="email" class="form-label">
                    Address:
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="text"
                    placeholder="Enter Your Warehouse Address"
                  />
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <label for="email" class="form-label">
                    Email:
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="text"
                    placeholder="Enter Email"
                  />
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <label for="email" class="form-label">
                    Mobile Number:
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="text"
                    placeholder="Enter Your Mobile Number"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a href="#" class="btn btn-primary">
                Submit
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- The Modal Weight Dispute Raise--> */}
      <div class="modal" id="WeightDis">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Raise Weight Dispute </h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div class="modal-body">
              <section class="chatting_lists">
                <div class="chat_list left_hand">
                  <img
                    src="https://avatar.iran.liara.run/username?username=Michel+Wilson"
                    class="img-fluid chat_list_img"
                  />
                  <div>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Magnam totam aperiam corrupti, voluptates repellat
                      laboriosam, culpa deleniti delectus maxime voluptatibus
                      est in nemo possimus minus soluta provident fugiat id
                      odit.
                    </p>
                    <strong>- Michel Wilson</strong> <small>just now</small>
                    <h6>Attachments</h6>
                    <div class="d-flex gap-2 mt-2">
                      <div class="text-center">
                        <a href="">
                          <img
                            src="https://picsum.photos/60"
                            alt=""
                            class="rounded-3 img-3x"
                          />
                        </a>
                        <h6>Picture</h6>
                      </div>
                      <div class="text-center">
                        <a href="">
                          <img
                            src="https://picsum.photos/60"
                            alt=""
                            class="rounded-3 img-3x"
                          />
                        </a>
                        <h6>Picture</h6>
                      </div>
                      <div class="text-center">
                        <a href="">
                          <img
                            src="https://picsum.photos/60"
                            alt=""
                            class="rounded-3 img-3x"
                          />
                        </a>
                        <h6>Video</h6>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chat_list right_hand">
                  <img
                    src="https://avatar.iran.liara.run/username?username=James+Kanday"
                    class="img-fluid chat_list_img"
                  />
                  <div>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Magnam totam aperiam corrupti, voluptates repellat
                      laboriosam, culpa deleniti delectus maxime voluptatibus
                      est in nemo possimus minus soluta provident fugiat id
                      odit.
                    </p>
                    <strong>- Michel Wilson</strong> <small>just now</small>
                    <h6>Attachments</h6>
                    <div class="d-flex gap-2 mt-2">
                      <div class="text-center">
                        <a href="">
                          <img
                            src="https://picsum.photos/600"
                            alt=""
                            class="rounded-3 img-3x"
                          />
                        </a>
                        <h6>Picture</h6>
                      </div>
                      <div class="text-center">
                        <a href="">
                          <img
                            src="https://picsum.photos/1000"
                            alt=""
                            class="rounded-3 img-3x"
                          />
                        </a>
                        <h6>Picture</h6>
                      </div>
                      <div class="text-center">
                        <a href="">
                          <img
                            src="https://picsum.photos/60"
                            alt=""
                            class="rounded-3 img-3x"
                          />
                        </a>
                        <h6>Video</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <div class="text-center">
                <a
                  href="#"
                  class="btn btn-danger"
                  data-bs-toggle="collapse"
                  data-bs-target="#reaise_disp"
                >
                  Reject
                </a>
                <a href="#" class="btn btn-success">
                  Accept
                </a>
                <a href="#" class="btn btn-secondary">
                  Close
                </a>
              </div>

              <div class="row" id="reaise_disp" class="collapse">
                <div class="col-12 col-md-12 mb-3">
                  <label for="email" class="form-label">
                    Enter Dispute Details:
                  </label>
                  <textarea
                    class="form-control"
                    rows="5"
                    id="comment"
                    name="text"
                    placeholder="Enter details"
                  ></textarea>
                </div>
                <div class="col-12 col-md-12 mb-3">
                  <label for="email" class="form-label">
                    Enter Dispute Details: (Upto 3 images/video max 100mb)
                  </label>
                  <input
                    type="file"
                    class="form-control"
                    id="text"
                    placeholder="Enter details name="
                  />
                </div>
                <div class="col-12 col-md-12 mb-3">
                  <a href="#" class="btn btn-primary">
                    Raise Weight Dispute
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- NDR History Modal --> */}
      <div class="modal" id="NDR_Modal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">NDR History: AWB #56789987676556</h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div class="modal-body">
              <div class="card bg-light mb-2">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-1">
                      <h1 class="text-dark">&#8226;</h1>
                    </div>
                    <div class="col-12 col-md-2">
                      <h6>Date</h6>
                      <small>2024-11-07 18:09</small>
                    </div>
                    <div class="col-12 col-md-2">
                      <h6>Action by</h6>
                      <small>Courier: DTDC</small>
                    </div>
                    <div class="col-12 col-md-2">
                      <h6>Remarks</h6>
                      <small>Out of Deliveyr Area</small>
                    </div>
                    <div class="col-12 col-md-2">
                      <h6>NDR Count #</h6>
                      <small>1</small>
                    </div>
                    <div class="col-12 col-md-2">
                      <h6>Action</h6>
                      <small>Change Phone</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card bg-light mb-2">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-1">
                      <h1 class="text-dark">&#8226;</h1>
                    </div>
                    <div class="col-12 col-md-2">
                      <h6>Date</h6>
                      <small>2024-11-07 18:09</small>
                    </div>
                    <div class="col-12 col-md-2">
                      <h6>Action by</h6>
                      <small>Courier: DTDC</small>
                    </div>
                    <div class="col-12 col-md-2">
                      <h6>Remarks</h6>
                      <small>Out of Deliveyr Area</small>
                    </div>
                    <div class="col-12 col-md-2">
                      <h6>NDR Count #</h6>
                      <small>1</small>
                    </div>
                    <div class="col-12 col-md-2">
                      <h6>Action</h6>
                      <small>Change Phone</small>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- <div class="table-responsive">
          <table class="table table-bordered table-hover table-sm">
            <thead  class="bg-table">
              <tr>
                <th>Date</th>
                <th>Action</th>
                <th>Updated Details (If Any)</th>
                <th>Remarks</th>
                <th>NDR Count #</th>
                <th>By</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2024-11-07 18:09</td>
                <td>Change Phone</td>
                <td>9677046969</td>
                <td>Dear team Pls call on this no. and arrange delivery tomorrow</td>
                <td class="text-center">1</td>
                <td>Seller</td>
              </tr>
              <tr>
                <td>2024-11-03 18:09</td>
                <td>NDR Raised</td>
                <td>-</td>
                <td>Customer Refused Delivery</td>
                <td class="text-center">1</td>
                <td>Courier</td>
              </tr>
            </tbody>
          </table>
        </div> --> */}
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Manifest History Modal --> */}
      <div class="modal" id="Manifest_Modal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Manifest ID: 56789987676556</h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div class="modal-body">
              <div class="table-responsive">
                <table class="table table-bordered table-hover table-sm">
                  <thead class="bg-table">
                    <tr>
                      <th>#</th>
                      <th>Order #</th>
                      <th>Carrier</th>
                      <th>AWB #</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>
                        <a href="#">1234567890</a>
                      </td>
                      <td>Delhivery</td>
                      <td>1234567890</td>
                      <td>Preapid</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>
                        <a href="#">1234567890</a>
                      </td>
                      <td>Delhivery</td>
                      <td>1234567890</td>
                      <td>COD - $98.39</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" id="no_kyc">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="error_kyc">
                <div class="text-center">
                  <h1 class="">
                    <i class="bi bi-person-vcard"></i>
                  </h1>
                </div>
                <p>
                  To enhance your experience and ensure seamless transactions,
                  we kindly request your cooperation in completing your Know
                  Your Customer (KYC) process. KYC verification is essential to
                  maintaining security and compliance standards.
                </p>

                <div class="text-start mt-4">
                  <h5>Benefits:</h5>
                  <ul>
                    <li>Unlock full account features</li>
                    <li>No restrictions on bookings</li>
                  </ul>

                  <h5>Without completing KYC:</h5>
                  <ul>
                    <li>Limit of 5 shipments bookings</li>
                  </ul>
                </div>

                <div class="row justify-content-between p-1 py-3">
                  <div class="col-12 col-md-6">
                    <div class="d-grid">
                      <a
                        href=""
                        class="btn btn-primary btn-block "
                        data-bs-dismiss="modal"
                      >
                        I understand
                      </a>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="d-grid">
                      <a
                        href="/bank_details"
                        class="btn btn-outline-danger  btn-block"
                      >
                        I'll do later!
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- notification The Modal --> */}
      <div class="notification_modal">
        <div class="modal" id="Notificion">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              {/* <!-- Modal Header --> */}
              <div class="modal-header">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>

              {/* <!-- Modal body --> */}
              <div class="modal-body">
                <div
                  id="Notificion_car"
                  class="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div class="carousel-indicators">
                    <button
                      type="button"
                      data-bs-target="#Notificion_car"
                      data-bs-slide-to="0"
                      class="active"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#Notificion_car"
                      data-bs-slide-to="1"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#Notificion_car"
                      data-bs-slide-to="2"
                    ></button>
                  </div>

                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <a href="https://google.com">
                        <img
                          src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/delivery-service-banner-ad-design-template-db6172d1b252e77bed358cf62aa53e1a_screen.jpg?ts=1733140838"
                          alt=""
                          class="d-block w-100"
                        />
                      </a>
                      <h5>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Eligendi, excepturi et vitae accusamus eveniet
                        dicta consequuntur quia, suscipit praesentium, obcaecati
                        atque? Nostrum, quia omnis neque blanditiis ad aut
                        debitis quod!
                      </h5>
                    </div>
                    <div class="carousel-item">
                      <img
                        src="https://cdn.create.vista.com/downloads/a65c247c-a0ae-4bf4-a624-220af72a471a_1024.jpeg"
                        alt=""
                        class="d-block w-100"
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        src="https://cdn.create.vista.com/downloads/ec639d41-94c7-464b-a080-5d97648f6331_1024.jpeg"
                        alt=""
                        class="d-block w-100"
                      />
                    </div>
                  </div>

                  {/* <!-- <button class="carousel-control-prev" type="button" data-bs-target="#Notificion_car" data-bs-slide="prev">
              <span class="carousel-control-prev-icon"></span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#Notificion_car" data-bs-slide="next">
              <span class="carousel-control-next-icon"></span>
            </button> --> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Common;
